import { useMemo } from "react";
import { useReservationStore } from "../../../stores/useReservationStore";
import { getProductLines } from "../utils/productQuantities";

export function useOrderTotal(
  ticketsTotal: number,
  donationAmount: number,
  shippingFee?: number,
) {
  const { products } = useReservationStore();

  return useMemo(() => {

    const productsTotal = getProductLines(products).reduce(
      (sum, { option, qty }) => {
        const price = option.discountedPrice ?? option.price ?? 0;
        return sum + price * qty;
      },
      0,
    );

    return ticketsTotal + productsTotal + donationAmount + (shippingFee ?? 0);
  }, [ticketsTotal, products, donationAmount, shippingFee]);
}